import { useEffect, useState } from 'react';
import { phTodayStr } from '../utils/phTime';

// Hour and minute in Manila time, read through Intl so the answer doesn't
// depend on the timezone of the guest's own device.
const PH_TIME_FORMAT = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Manila', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

/**
 * Today's date and the minute of the day, both in PH (club) time.
 *
 * @returns {{todayStr: string, minutes: number}} 'yyyy-MM-dd' and 0-1439
 */
const readPhClock = () => {
  const parts = PH_TIME_FORMAT.formatToParts(new Date());
  const read = (type) => Number(parts.find(part => part.type === type)?.value) || 0;
  return {
    todayStr: phTodayStr(),
    minutes: (read('hour') % 24) * 60 + read('minute'),
  };
};

/**
 * The PH clock, re-read on an interval so a screen left open keeps up with
 * the time — the guest grid uses it to turn a slot to Passed the minute it
 * ends, and the date rolls over at midnight without a reload.
 *
 * @param {number} [intervalMs] - how often to re-read; 30s keeps a flip within
 *   half a minute of the real time
 * @returns {{todayStr: string, minutes: number}}
 */
function usePhClock(intervalMs = 30000) {
  const [clock, setClock] = useState(readPhClock);

  useEffect(() => {
    const timer = setInterval(() => {
      const next = readPhClock();
      // Only re-render when the minute or date actually changed.
      setClock(prev => (prev.minutes === next.minutes && prev.todayStr === next.todayStr ? prev : next));
    }, intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return clock;
}

export default usePhClock;
